import { IErrorData } from "@/common/services/types";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiMain } from "@/common/services";
import { AxiosError } from "axios";
import { sfwUrl } from "@/common/utils/env";
import { routes } from "@/common/utils/routes";
import { onCloseVerificationPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { PROFILE_VERIFICATION_PENDING_STATUS, PROFILE_VERIFICATION_WAITING_STATUS } from "@/common/utils/constants";
import { popupBus } from "@/common/buses";
import { PopupsEnum } from "@/components/popup-dispatcher/PopupDispatcher/popups";

export const useVerificationPopup = () => {
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [profileVerificationStatus, setProfileVerificationStatus] = useState<string | null>(null);

  const navigate = useNavigate();

  const onVerifyAge = useCallback(async () => {
    try {
      setLoading(true);
      const { sessionUrl } = await apiMain.verifyAge();
      window.location.href = sessionUrl;
    } catch (e) {
      const err = e as AxiosError<IErrorData>;
      setError(err.response?.data?.error?.message || "An error occurred, please try again later");
      setLoading(false);
    }
  }, []);

  const onCancelVerification = useCallback(() => {
    window.location.href = `${sfwUrl}?explain=0`;
  }, []);

  const onStartVerification = useCallback(() => {
    onCloseVerificationPopup();
    navigate(routes.verify());
  }, []);

  const profileVerificationDone = useMemo(() => {
    return [
      PROFILE_VERIFICATION_PENDING_STATUS,
      PROFILE_VERIFICATION_WAITING_STATUS
    ].includes(profileVerificationStatus || "");
  }, [profileVerificationStatus]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await apiMain.getVerifyUserStatus();
        setProfileVerificationStatus(response.status);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    popupBus.emit("opened", { name: PopupsEnum.Verification });
  }, []);

  return {
    error,
    isLoading,
    profileVerificationDone,
    onCancelVerification,
    onStartVerification,
    onVerifyAge,
  };
};
